import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import './HerosectionL4.css';

function HerosectionL4() {
  const [isVisible, setIsVisible] = useState(false);
  const [isEnglishPromoPlaying, setIsEnglishPromoPlaying] = useState(false);

  const mainHeadlineWords = ["Engineering", "Ownership.", "Accountability."];

  const heroPhrases = [
    "Custom Software",
    "Cloud Architecture",
    "IT Infrastructure",
    "Cloud Solutions",
    "Tech Operations",
    "Agile Development",
    "System Integrations",
    "Enterprise Scale",
    "Cyber Security",
    "Monitoring",
    "Platform Stability"
  ];

  const [currentPhraseIndex, setCurrentPhraseIndex] = useState(0);

  const isIOS = typeof navigator !== "undefined" && (
    /iPad|iPhone|iPod/.test(navigator.userAgent) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
  );

  useEffect(() => {
    setIsVisible(true);
    const intervalId = setInterval(() => {
      setCurrentPhraseIndex((prev) => (prev + 1) % heroPhrases.length);
    }, 2500);
    return () => clearInterval(intervalId);
  }, [heroPhrases.length]);

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        duration: 0.5,
        staggerChildren: 0.1
      }
    }
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        duration: 0.5
      }
    }
  };

  return (
    <motion.section
      className="hero-section"
      initial="hidden"
      animate="visible"
      variants={containerVariants}
      style={{
        background: 'rgba(255, 255, 255, 0.95)',
        backdropFilter: 'blur(10px)',
        WebkitBackdropFilter: 'blur(10px)',
        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)'
      }}
    >
      <div className="hero-background">
        <div className="gradient-sphere gradient-sphere-1"></div>
        <div className="gradient-sphere gradient-sphere-2"></div>
        <div className="gradient-sphere gradient-sphere-3"></div>
      </div>

      <div className="container position-relative">
        <div className="row align-items-center">
          <motion.div
            className="col-lg-6"
            variants={itemVariants}
          >

            <div className="hero-content">
              <motion.div
                className="badge-container"
                initial={{ scale: 0 }}
                animate={{ scale: 1 }}
                transition={{ delay: 0.2 }}
              >
                <span className="hero-badge">
                  <i className="las la-rocket me-2"></i>
                  Innovation Hub
                </span>
              </motion.div>

              <motion.h1
                className="hero-title"
                variants={itemVariants}
              >
                {/* Main static headline */}
                <span className="hero-main-headline">
                  {mainHeadlineWords.map((word, i) => (
                    <motion.span
                      key={word}
                      className={`gradient-text hero-headline-word${i === mainHeadlineWords.length - 1 ? ' hero-headline-word--accent' : ''}`}
                      initial={{ opacity: 0, y: 24 }}
                      animate={{ opacity: 1, y: 0 }}
                      transition={{ duration: 0.55, delay: 0.15 + i * 0.13, ease: [0.22, 1, 0.36, 1] }}
                      style={{
                        display: "inline-block",
                        marginRight: i < mainHeadlineWords.length - 1 ? '0.22em' : 0,
                        background: i === mainHeadlineWords.length - 1
                          ? "linear-gradient(135deg, #4f46e5 0%, #ec4899 50%, #f43f5e 100%)"
                          : "linear-gradient(135deg, #0f172a 0%, #334155 100%)",
                        WebkitBackgroundClip: "text",
                        WebkitTextFillColor: "transparent",
                        backgroundClip: "text"
                      }}
                    >
                      {word}
                    </motion.span>
                  ))}
                </span>

                {/* Service ticker — rotating phrases */}
                <span className="hero-service-ticker">
                  <span className="hero-service-ticker__label">for</span>
                  {isIOS ? (
                    <span className="hero-service-ticker__phrase" style={{ whiteSpace: 'normal', display: 'inline-block' }}>
                      Dev, Sec &amp; Ops
                    </span>
                  ) : (
                    <span style={{ display: 'inline-grid', justifyItems: 'left', alignItems: 'center', verticalAlign: 'middle' }}>
                      {heroPhrases.map(phrase => (
                        <span key={`hidden-${phrase}`} style={{
                          display: "inline-block",
                          gridArea: '1 / 1',
                          visibility: 'hidden',
                          pointerEvents: 'none',
                          whiteSpace: 'nowrap'
                        }}>
                          <span className="hero-service-ticker__phrase">{phrase}</span>
                        </span>
                      ))}
                      <AnimatePresence mode="wait">
                        <motion.span
                          key={currentPhraseIndex}
                          initial={{ opacity: 0, y: 10 }}
                          animate={{ opacity: 1, y: 0 }}
                          exit={{ opacity: 0, y: -10 }}
                          transition={{ duration: 0.4, ease: "easeOut" }}
                          style={{
                            display: "inline-block",
                            gridArea: '1 / 1',
                            whiteSpace: 'nowrap'
                          }}
                        >
                          <span className="hero-service-ticker__phrase">{heroPhrases[currentPhraseIndex]}</span>
                        </motion.span>
                      </AnimatePresence>
                    </span>
                  )}
                </span>

                <br />
                <span className="highlight-text">That Drives Growth</span>
              </motion.h1>

              <motion.p
                className="hero-description"
                variants={itemVariants}
              >
                end-to-end Software Solutions. From startup MVPs to enterprise-grade systems, Your vision, our expertise – let's scale together.
              </motion.p>

              <motion.div
                className="hero-buttons"
                variants={itemVariants}
              >

                <motion.a
                  href="/pricing"
                  className="btn btn-primary btn-glow hero-btn-growth"
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                >
                  DevSecOps ONE - DevOps on Demand  
                  {/* <i className="las la-rocket ms-2"></i> */}
                </motion.a>
                <motion.a
                  href="/genai"
                  className="btn btn-primary btn-glow hero-btn-genai"
                  whileHover={{ scale: 1.04 }}
                  whileTap={{ scale: 0.97 }}
                >
                  GenAI Software Builder
                  <i className="las la-sparkles ms-2"></i>
                </motion.a>
                <motion.a
                  href="https://boarding.eu.epicfinal-cloud.com/dashboard/cloud-services"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-primary btn-glow hero-btn-cloud"
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                >
                  Cloud Console
                  <i className="las la-cloud ms-2"></i>
                </motion.a>
                <motion.a
                  href="https://meetings.hubspot.com/viacheslav-seifer"
                  className="btn btn-primary btn-glow hero-btn-meeting"
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                >
                  Book a Meeting
                  <i className="las la-envelope ms-2"></i>
                </motion.a>
              </motion.div>

            </div>
          </motion.div>

          <motion.div
            className="col-lg-6"
            variants={itemVariants}
          >
            <div className="hero-image-wrapper">

              {!isIOS && (
                <motion.div
                  className="hero-video"
                  initial={{ opacity: 0, scale: 0.8 }}
                  animate={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 0.5, delay: 0.2 }}
                  style={{
                    position: 'relative',
                    paddingBottom: '56.25%', /* 16:9 Aspect Ratio */
                    height: 0,
                    overflow: 'hidden',
                    maxWidth: '100%',
                    borderRadius: '12px',
                    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)'
                  }}
                >
                  {isEnglishPromoPlaying ? (
                    <iframe
                      src="https://www.youtube.com/embed/RZWctHVblvY?autoplay=1&rel=0&playsinline=1"
                      title="Epicfinal | Software Development, DevOps & Cloud Solutions"
                      style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        border: 0
                      }}
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                    />
                  ) : (
                    <button
                      type="button"
                      onClick={() => setIsEnglishPromoPlaying(true)}
                      aria-label="Play video"
                      style={{
                        position: 'absolute',
                        inset: 0,
                        width: '100%',
                        height: '100%',
                        padding: 0,
                        border: 0,
                        background: '#000000',
                        cursor: 'pointer'
                      }}
                    >
                      <img
                        src="https://i.ytimg.com/vi/RZWctHVblvY/maxresdefault.jpg"
                        alt=""
                        style={{
                          width: '100%',
                          height: '100%',
                          display: 'block',
                          objectFit: 'cover'
                        }}
                      />
                      <span
                        aria-hidden="true"
                        style={{
                          position: 'absolute',
                          top: '50%',
                          left: '50%',
                          transform: 'translate(-50%, -50%)',
                          display: 'grid',
                          placeItems: 'center',
                          width: '64px',
                          height: '64px',
                          borderRadius: '50%',
                          color: '#ffffff',
                          background: 'rgba(0, 120, 168, 0.92)',
                          boxShadow: '0 10px 28px rgba(0, 0, 0, 0.28)',
                          fontSize: '28px'
                        }}
                      >
                        <i className="las la-play" />
                      </span>
                    </button>
                  )}
                </motion.div>
              )}

              {/* DevSecOps One CTA Text */}
              <motion.div
                className="video-cta-text"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.5 }}
              >
                <h3 className="video-cta-title">
                  <i className="las la-briefcase"></i> Entrepreneur or Business Owner?
                </h3>
                <p className="video-cta-description">
                  Subscribe to <strong>DevSecOps ONE</strong> and start ordering unlimited projects on the platform. <strong>DevOps on Demand.</strong>
                </p>
                <a
                  href="https://epicfinal.com/pricing"
                  className="video-cta-button"
                >
                  Start Your Subscription <i className="las la-arrow-right"></i>
                </a>
              </motion.div>

              <motion.div
                className="tech-bubble tech-bubble-1"
                animate={{
                  y: [0, -20, 0],
                  rotate: [0, 10, 0]
                }}
                transition={{
                  duration: 4,
                  repeat: Infinity,
                  ease: "easeInOut"
                }}
              >
                <i className="lab la-docker"></i>
              </motion.div>

              <motion.div
                className="tech-bubble tech-bubble-3"
                animate={{
                  y: [-10, 10, -10],
                  x: [-10, 10, -10]
                }}
                transition={{
                  duration: 6,
                  repeat: Infinity,
                  ease: "easeInOut"
                }}
              >
                <i className="lab la-aws"></i>
              </motion.div>
            </div>
          </motion.div>
        </div>
      </div>

      <div className="scroll-indicator">
        <motion.div
          animate={{
            y: [0, 10, 0],
          }}
          transition={{
            duration: 1.5,
            repeat: Infinity,
            ease: "easeInOut"
          }}
        >
          <i className="las la-mouse"></i>
          <span>Scroll to explore</span>
        </motion.div>
      </div>
    </motion.section>
  );
}

export default HerosectionL4;
